import axios from "axios";
import config from "src/config";

const URLCLOSESESSION = config.url.URLCLOSESESSION;

export const SessionsAPI = {
  async close(contextData, requestData) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'customer': contextData.clientId,
        'session-id': contextData.sessionId,
        'sso': contextData.cookie
      }
      const response = await axios.post(URLCLOSESESSION, requestData, { headers });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
};
